module.exports = __webpack_public_path__ + "img/boxpt_background.5caa33e3.svg";